import AnimalSelectionScreen from "screens/AnimalSelectionScreen"
import RemoveBackgroundScreen from "screens/RemoveBackgroundScreen"
import styles from 'styles/RemoveBgAnimalScreen.module.css';

type RemoveBgAnimalSelectionScreenPropsType = {
    firebaseRef?: any;
    skipScreen?: boolean;
    socketInstance: any;
}

function RemoveBgAnimalSelectionScreen({ firebaseRef, skipScreen, socketInstance }: RemoveBgAnimalSelectionScreenPropsType) {
  return <> 
  <div className={!skipScreen && styles.hidden || ''}>
    <AnimalSelectionScreen firebaseRef={firebaseRef} socketInstance={socketInstance}/>
  </div>
  <div className={skipScreen && styles.hidden || ''}>
    <RemoveBackgroundScreen/>
  </div>
</>
}

export default RemoveBgAnimalSelectionScreen
